// extracted by mini-css-extract-plugin
export default {"link":"eM-z","disabled":"fM-z"};